import {
  useAvailabilitySlotTypes,
  TimeSlotTypeChip,
} from '@product-framework/index';
import { Stack } from '@mui/material';

function DateCellContent({
  cellDateValue,
  textDate,
  gridKey,
  setSelectedDayAndSlot,
  setErrors,
}) {
  const { getSlotByCode } = useAvailabilitySlotTypes();

  const slots = Array.isArray(cellDateValue?.slots) ? cellDateValue.slots : [];

  if (cellDateValue?.available) {
    return slots.map(slotKey => {
      const slotFound = getSlotByCode({ code: slotKey.code });

      return (
        <Stack key={slotKey?.code}>
          <TimeSlotTypeChip
            onClick={() => {
              setErrors(null);
              setSelectedDayAndSlot({ slot: slotKey, textDate });
            }}
            key={`${gridKey}${slotKey?.code}`}
            name={slotFound?.name || slotKey.code}
            code={slotKey.code}
            showScore
            score={slotKey?.score || 0}
          />
        </Stack>
      );
    });
  }
  return null;
}

export default DateCellContent;
